import React, { useState, useEffect } from "react";
import "../assets/styles/services.css";
import ser1 from "../assets/images/ser1.svg";
import ser2 from "../assets/images/ser2.svg";
import s1 from "../assets/images/s1.svg";
import s2 from "../assets/images/s2.svg";
import s3 from "../assets/images/s3.svg";
import s4 from "../assets/images/s4.svg";
import s5 from "../assets/images/s5.svg";
import s6 from "../assets/images/s6.png";

const servicesData = [
  {
    icon: s1,
    title: "AI Solutions",
    description:
      "Empower your business with AI. From machine learning algorithms to data-driven analytics, our AI solutions ensure smarter decision-making and automation.",
  },
  {
    icon: s2,
    title: "Website Development",
    description:
      "Elevate your online presence with stunning websites built on the MERN stack. Fully responsive, SEO-friendly, and optimized for performance.",
  },
  {
    icon: s3,
    title: "Mobile App Development",
    description:
      "Create seamless, feature-rich apps with Flutter and other leading technologies. Whether Android or iOS, we deliver apps that captivate users.",
  },
  {
    icon: s4,
    title: "Software Testing Services",
    description:
      "Deliver perfection with our robust software testing services. We ensure your applications are bug-free, secure, and perform flawlessly.",
  },
  {
    icon: s5,
    title: "UX/UI Design",
    description:
      "A business strategy is powerful for helping you reach your goals, defining the methods and tactics.",
  },
  {
    icon: s6,
    title: "AR/VR & Immersive Experiences",
    description:
      "Delivering next-level engagement through custom built augmented and virtual reality solutions for education, marketing, training, and beyond.",
  },
];

const ServicesSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1108);
  const [isManual, setIsManual] = useState(false); // Flag to track manual control

  // Adjust for window resizing
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1108);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Automatic sliding on mobile devices
  useEffect(() => {
    if (isMobile && !isManual) {
      const interval = setInterval(() => {
        setActiveIndex((prevIndex) => (prevIndex + 1) % servicesData.length);
      }, 3000); // Auto-slide every 3 seconds
      return () => clearInterval(interval); // Cleanup interval on unmount or manual interaction
    }
  }, [isMobile, isManual]);

  // Handle manual dot click
  const handleDotClick = (index) => {
    setActiveIndex(index);
    setIsManual(true); // Mark as manual interaction
  };

  return (
    <section className="services-section">
      <div className="services-header">
        <h2 className="services-title">
          <div className="line-container">
            <img src={ser1} alt="Line 1" className="line" />
            <img src={ser2} alt="Line 2" className="line" />
            Our Services
          </div>
        </h2>
      </div>

      {isMobile ? (
        <div className="services-display">
          {servicesData.map((service, index) => (
            <div
              key={index}
              className={`service-card ${
                index === activeIndex ? "active" : "hidden"
              }`}
            >
              <div className="service-icon">
                <img src={service.icon} alt={service.title} />
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      ) : (
        <div className="services-grid">
          {servicesData.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                <img src={service.icon} alt={service.title} />
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      )}

      {isMobile && (
        <div className="service-dots">
          {servicesData.map((_, index) => (
            <div
              key={index}
              className={`dot ${index === activeIndex ? "active" : ""}`}
              onClick={() => handleDotClick(index)} // Manual dot click
            ></div>
          ))}
        </div>
      )}
    </section>
  );
};

export default ServicesSection;
